<template>
  <v-container fluid>
    <v-breadcrumbs>
      <v-breadcrumbs-item to="/secure/courses/management"
        >Course Management</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :disabled="true">New Course</v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-stepper class="mb-5" v-model="step">
      <v-stepper-header>
        <v-stepper-step @click="toStep('info')" step="1">General Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step @click="toStep('schedule')" step="2"
          >Schedule</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step @click="toStep('curriculum')" step="3">Curriculum</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step @click="toStep('planning')" step="4">Planning</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step @click="toStep('review')" step="5">Review</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-card v-if="step == 1">
      <v-card-text>
        <v-form ref="infoForm" v-model="valid" lazy-validation>
          <v-select
            :items="centers"
            v-model="course.center"
            label="Center*"
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
            @change="loadPrograms(course.center)"
          />
          <v-select
            :items="programs"
            v-model="course.program"
            label="Program*"
            item-text="name"
            item-value="id"
            :hint="program.description"
            :rules="[rules.required]"
            no-data-text="Choose a center first"
            @change="setCoursePrice"
            clearable
          />
          <v-select
            v-model="course.grade"
            :items="grades"
            item-text="name"
            item-value="value"
            label="Grade*"
          ></v-select>
          <v-text-field
            data-cy="nameinput"
            label="Course name*"
            v-model="course.name"
            :rules="[rules.required]"
          />
          <v-text-field
            data-cy="descriptionHeading"
            label="Course description heading"
            v-model="course.descriptionHeading"
          />
          <v-textarea
            label="Course description"
            :auto-grow="true"
            rows="1"
            v-model="course.description"
          />
          <!-- <v-select
            v-model="course.subject"
            :items="subjects"
            label="Subject"
          ></v-select> -->
          <v-radio-group
            v-model="course.chargeType"
            :row="true"
            label="Charge by"
            :disabled="true"
            :rules="[rules.required]"
          >
            <v-radio value="Session" label="Session" />
            <v-radio value="Month" label="Monthly" />
            <!-- <v-radio value="Week" label="Weekly" /> -->
            <v-radio value="Course" label="Course" />
          </v-radio-group>
          <v-text-field
            prefix="$"
            :label="`Price per ${course.chargeType}*`"
            v-model="course.price"
            :rules="[rules.required]"
          />
          <v-text-field
            type="number"
            min="0"
            max="10"
            label="Max capacity"
            v-model="course.capacity"
          />
          <v-switch
            v-model="course.openEnroll"
            :label="`Open enrollment: ${course.openEnroll ? 'Yes' : 'No'}`"
          ></v-switch>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="checkGeneralInfo">Next</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <v-card v-if="step == 2">
      <course-schedule-form
        @clickBack="toStep('info')"
        @clickNext="toStep('curriculum')"
        v-model="schedule"
      />
    </v-card>

    <v-card v-if="step == 3">
      <v-toolbar collapse dense>
        <v-spacer />Topics
        <choose-course-topic
          :subject="course.subject"
          :grade="course.grade"
          @selectedTopics="selectedTopics"
        />
      </v-toolbar>
      <v-card-text>
        <v-card
          class="my-5"
          v-for="(topic, index) in course.courseTopics"
          :key="index"
        >
          <v-card-title class="d-flex flex-row">
            Topic {{ index + 1 }}
            <v-spacer />
            <v-btn @click="deleteTopic(index)" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="topic.name"
              hint="You could also search for an existing topic"
              label="Topic Name"
            ></v-text-field>

            <div
              v-if="
                topic['topic_topicMaterials'] &&
                topic['topic_topicMaterials'].length > 0
              "
            >
              Found {{ topic["topic_topicMaterials"].length }} materials
              associated with this topic
              <div v-for="cm in topic['topic_topicMaterials']" :key="cm.id">
                {{ cm.materials.name }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="mr-5">
        <v-btn @click="toStep('schedule')">Back</v-btn>
        <v-spacer />
        <v-btn @click="addMoreTopic">Add More Topic</v-btn>
        <v-btn @click="skipCurriculum">Skip Curriculum</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="toStep('planning')">Next</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="step == 4">
      <v-card-title>Plan scheduled curriculum</v-card-title>
      <v-card-text>
        <v-simple-table v-if="schedulePlan && schedulePlan.length > 0">
          <thead>
            <tr>
              <td width="40%">Week</td>
              <td width="60%">Topics</td>
            </tr>
          </thead>
          <tr v-for="(plan, index) in schedulePlan" :key="index">
            <td>
              Week {{ index + 1 }} ({{
                plan.dates.map((d) => d.format("MMM Do")).join(", ")
              }})
            </td>
            <td>
              <v-select
                multiple
                chips
                v-model="plan.topics"
                :deletable-chips="true"
                :items="course.courseTopics"
                item-text="name"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    close
                    class="chip--select-multi"
                    @click="topicChipClick"
                    >{{ data.item.name }}</v-chip
                  >
                </template>
              </v-select>
            </td>
          </tr>
        </v-simple-table>
        <div v-else>
          Please define a schedule and add topics to curriculum before planning
        </div>
      </v-card-text>
      <v-card-actions class="mr-5">
        <v-btn primary @click="toStep('curriculum')">Back</v-btn>
        <v-spacer />
        <v-btn primary @click="toStep('review')">Next</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="step == 5">
      <v-card-subtitle>General Info</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12">Name: {{ course.name }}</v-col>
          <v-col cols="12">
            Description:
            <br />
            <b>{{ course.descriptionHeading }}</b>
            {{ course.description }}
          </v-col>
          <v-col cols="12" lg="6">Grade: {{ course.grade }}</v-col>
          <v-col cols="12" lg="6">Subject: {{ course.subject }}</v-col>
          <v-col cols="12" lg="6"
            >Price per session: {{ course.pricePerSession }}</v-col
          >
          <v-col cols="12" lg="6"
            >Price per course: {{ course.pricePerCourse }}</v-col
          >
          <v-col cols="12" lg="6">Capacity: {{ course.capacity }}</v-col>
          <v-col cols="12" lg="6"
            >Open for enrollment: {{ course.openEnroll }}</v-col
          >
        </v-row>
      </v-card-text>
      <v-card-subtitle>Schedule</v-card-subtitle>
      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <td>Week</td>
              <td>Topics</td>
            </tr>
          </thead>
          <tr v-for="(plan, index) in schedulePlan" :key="index">
            <td>
              Week {{ index + 1 }} ({{
                plan.dates.map((d) => d.format("MMM Do")).join(", ")
              }})
            </td>
            <td>
              <v-chip
                class="mr-5"
                v-for="(topic, index) in plan.topics"
                :key="index"
                >{{ topic }}</v-chip
              >
            </td>
          </tr>
        </v-simple-table>

      </v-card-text>
      <v-card-actions>
        <v-btn @click="toStep('planning')">Back</v-btn>
        <v-spacer />
        <v-btn color="primary" :disabled="isAppLoading" @click="saveCourse">Save</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { rrulestr } from "rrule";
// import draggable from 'vuedraggable'
const ChooseCourseTopic = () =>
  import("@/components/course/ChooseCourseTopic.vue");
const CourseScheduleForm = () => import("@/components/course/CourseScheduleForm.vue");
// import moment from "moment";

import * as scheduleUtils from "@/components/course/schedule.js";
import {rules} from "@/store/util/rules.js";

export default {
  data() {
    return {
      loading: true,
      step: 1,
      valid: false,
      availableOwners: [],
      course: {
        name: "",
        description: "",
        descriptionHeading: "",
        subject: "",
        grade: "",
        chargeType: "Session",
        pricePerSession: 0,
        pricePerWeek: 0,
        pricePerCourse: 0,
        capacity: 0,
        openEnroll: false,
        courseOwner: null,
        courseTopics: [{ name: "" }],
        scheduleStart: null,
        scheduleEnd: null,
        program: null,
        center: null,
        teacherIds: []
      },
      schedule: {},
      centers: [],
      programs: [],
      program: {},
      teachers: [],
      rules
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "grades", "subjects"]),
    schedulePlan(){
      if(this.schedule.rrule == null){
        return [];
      }

      //group schedule to plan
      const rule = rrulestr(this.schedule.rrule);
      const scheduledDates = rule.all(function (date, i){return i < 300});

      const groupedInfo = scheduleUtils.groupSchedulesByWeeks(scheduledDates);
      console.log(groupedInfo);

      return groupedInfo.schedulePlan;
    }
  },
  watch: {},
  components: {
    ChooseCourseTopic,
    CourseScheduleForm,
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    addMoreTopic() {
      this.course.courseTopics.push({ name: "" });
    },
    deleteTopic(index) {
      this.course.courseTopics.splice(index, 1);
    },
    loadTeachers() {
      const data = {
        pageSize: 100,
        sortInfos: [{ sortCol: 'firstName', sortDir: 'asc'}],
        registered: true
      };

      this.$axios
        .post("/teacher/search", data)
        .then(resp => {
          this.teachers = resp.data.data.content.map( t => {return Object.assign( {name: `${t.firstName} ${t.lastName}`}, t) });
        })
        .catch(() => {
          this.addErrorMessage("Error loading teachers from server");
        });

    },
    loadOwners() {
      const params = { internalDomainOnly: true };
      return this.$axios.get("/classroom/teachers", { params }).then((resp) => {
        const teachers = resp.data;
        this.availableOwners = teachers.map((teacher) => {
          return {
            ...teacher,
            name: `${teacher.firstName} ${teacher.lastName.charAt(0)}. (${
              teacher.email
            })`,
          };
        });
      });
    },
    selectedTopics(topics) {
      console.log("Selected topics");
      console.log(topics);
      //add topics to course.courseTopics
      //remove any existing empty topic
      const courseTopics = this.course.courseTopics.filter(
        (topic) => topic.name
      );
      console.log(courseTopics);
      this.course.courseTopics = [...courseTopics, ...topics];
    },
    saveCourse() {

      this.course.schedule = {courseSchedules: [this.schedule]}
      this.course.programId = this.course.program;
      this.course.centerId = this.course.center;

      if (this.course.chargeType == "Session") {
        this.course.pricePerSession = this.course.price;
      } else if (this.course.chargeType == "Week") {
        this.course.pricePerWeek = this.course.price;
      } else if (this.course.chargeType == "Course") {
        this.course.pricePerCourse = this.course.price;
      }

      //Save course and topic
      this.$axios
        .post("/course/new", this.course)
        .then((resp) => {
          const newCourse = resp.data;

          this.$router.push({
            name: "CourseDetail",
            params: { id: newCourse.id },
          });
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });

      //Save plan (schedule to topics)
    },
    topicChipClick() {
      console.log("clicked chip");
    },
    loadCenters() {
      this.$axios.get("/center/get-my-centers").then((resp) => {
        this.centers = resp.data;
      });
    },
    loadPrograms(center) {
      const params = { centerId: center };
      this.$axios.get("/program/get-by-center", { params }).then((resp) => {
        this.programs = resp.data;
      });
    },
    setCoursePrice(programId) {

      this.program = this.programs.find((p) => (p.id == programId));

      let payTerm2ChargeType = new Map();
      payTerm2ChargeType["session"] = "Session";
      payTerm2ChargeType["subscription"] = "Month";
      payTerm2ChargeType["flat rate"] = "Course";

      this.course.chargeType = payTerm2ChargeType[this.program.payTerm];
      if (this.program.subject) {
        this.course.subject = this.program.subject;
      }

      this.course.capacity = this.program.studentTeacherRatio;
      this.course.price = this.program.standardRate;

      if (this.course.chargeType == "Session") {
        this.course.pricePerSession = this.course.price;
      } else if (this.course.chargeType == "Week") {
        this.course.pricePerWeek = this.course.price;
      } else if (this.course.chargeType == "Course") {
        this.course.pricePerCourse = this.course.price;
      }
    },
    checkGeneralInfo(){
      if (!this.$refs.infoForm.validate()) return;

      this.toStep('schedule')
    },
    skipCurriculum(){
      this.course.courseTopics = [];
      this.toStep('review')
    },
    toStep(name){
      let name2step = new Map();
      name2step['info'] = 1;
      name2step['schedule'] = 2;
      name2step['curriculum'] = 3;
      name2step['planning'] = 4;
      name2step['review'] = 5;
      this.step = name2step[name];
    },
  },
  mounted() {
    this.loadOwners();
    this.loadCenters();
    this.loadTeachers();
  },
};
</script>

<style>
</style>